import { NonConformiteCategorieEnum } from '@graphql/generated';
import { NonConformiteCategorie } from './../../models/demande-affiliation/types/non-conformite-categorie.type';

export class NonConformiteCategorieMapper {
  public static fromGraphQl(
    input?: NonConformiteCategorieEnum
  ): NonConformiteCategorie | undefined {
    const mapping: Record<NonConformiteCategorieEnum, NonConformiteCategorie> = {
      INFORMATIONS_MANQUANTES: 'informations_manquantes',
      MAUVAISE_QUALITE: 'mauvaise_qualite',
      RECTO_MANQUANT: 'recto_manquant',
      VERSO_MANQUANT: 'verso_manquant',

      JD_NON_SIGNE_FORMATEUR: 'jd_non_signe_formateur',
      JD_NON_SIGNE_FILLEUL: 'jd_non_signe_filleul',
      JD_NON_SIGNE_FORMATEUR_FILLEUL: 'jd_non_signe_formateur_filleul',
      JD_CONSULTANT_NON_MANAGER: 'jd_consultant_non_manager',
      JD_PLUS_UN_AN: 'jd_plus_un_an',
      JD_ANCIENNE_VERSION: 'jd_ancienne_version',
      JD_MAUVAIS_DOCUMENT: 'jd_mauvais_document',

      ESP_MAUVAIS_DOCUMENT_FORMULAIRE: 'esp_mauvais_document_formulaire',
      ESP_MAUVAIS_DOCUMENT: 'esp_mauvais_document',
      ESP_NON_SIGNE_ANIMATEUR: 'esp_non_signe_animateur',
      ESP_NON_SIGNE_FILLEUL: 'esp_non_signe_filleul',
      ESP_NON_SIGNE_ANIMATEUR_FILLEUL: 'esp_non_signe_animateur_filleul',
      ESP_ABSENCE_NOM_PARRAIN: 'esp_absence_nom_parrain',
      ESP_ANCIENNE_VERSION: 'esp_ancienne_version',

      PI_CNI_MAUVAIS_DOCUMENT: 'pi_cni_mauvais_document',
      PI_CNI_EXPIRE_MINEUR: 'pi_cni_expire_mineur',
      PI_CNI_EXPIRE_MAJEUR: 'pi_cni_expire_majeur',
      PI_PASS_MAUVAIS_DOCUMENT: 'pi_pass_mauvais_document',
      PI_PASS_EXPIRE: 'pi_pass_expire',
      PI_TS_MAUVAIS_DOCUMENT: 'pi_ts_mauvais_document',
      PI_TS_EXPIRE: 'pi_ts_expire',
      PI_TS_BIENTOT_EXPIRE: 'pi_ts_bientot_expire',

      CT_MAUVAIS_DOCUMENT: 'ct_mauvais_document',
      CT_EXPIRE: 'ct_expire',
      CT_NOM_SOCIETE_INVALIDE: 'ct_nom_societe_invalide',

      SS_MAUVAIS_DOCUMENT: 'ss_mauvais_document',
      SS_OBJET_INVALIDE: 'ss_objet_invalide',
      SS_NON_SIGNE: 'ss_non_signe',

      KBIS_MAUVAIS_DOCUMENT: 'kbis_mauvais_document',
      KBIS_PLUS_TROIS_MOIS: 'kbis_plus_trois_mois',
      KBIS_MAUVAISE_SOCIETE: 'kbis_mauvaise_societe',
      KBIS_PLUSIEURS_GERANTS: 'kbis_plusieurs_gerants',
      KBIS_GERANT_DIFFERENT_SOCIETE: 'kbis_gerant_different_societe',
      KBIS_GERENT_DIFFERENT_FILLEUL: 'kbis_gerent_different_filleul',
      KBIS_ACTIVITES_INVALIDES: 'kbis_activites_invalides',

      // ------- ValidationPj -------
      RCP_CARTET_NON_COUVERTE: 'rcp_carteT_non_couverte',
      RCP_EXPIRE: 'rcp_expire',
      RCP_HABILITATION_NON_COUVERTE: 'rcp_habilitation_non_couverte',
      RCP_IDENTITE_NON_CONFORME: 'rcp_identite_non_conforme',
      RCP_INCOMPLETE: 'rcp_incomplete',
      RCP_MAUVAIS_DOCUMENT: 'rcp_mauvais_document',

      RSAC_IDENTITE_NON_CONFORME: 'rsac_identite_non_conforme',
      RSAC_MAUVAIS_DOCUMENT: 'rsac_mauvais_document',
      RSAC_PLUS_TROIS_MOIS: 'rsac_plus_trois_mois',

      RIB_NON_CONFORME: 'rib_non_conforme',
      RIB_COMPTE_JOINT: 'rib_compte_joint',

      ATT_FORMATION_AUCUNE_ACTIVITE_STEFI: 'att_formation_aucune_activite_stefi',
      ATT_FORMATION_AUCUNE_FORMATION_CONTINUE: 'att_formation_aucune_formation_continue',
      ATT_FORMATION_IDENTITE_NON_CONFORME: 'att_formation_identite_non_conforme',
      ATT_FORMATION_MAUVAIS_DOCUMENT: 'att_formation_mauvais_document',
      ATT_FORMATION_QUOTA_HEURE: 'att_formation_quota_heure',
      ATT_FORMATION_VALIDATE_AVANT_HAB: 'att_formation_validate_avant_hab',

      CERTIFICAT_TRAVAIL_IDENTITE_NON_CONFORME:
        'certificat_travail_identite_non_conforme',
      CERTIFICAT_TRAVAIL_MAUVAIS_DOCUMENT: 'certificat_travail_mauvais_document',

      DIPLOME_IDENTITE_NON_CONFORME: 'diplome_identite_non_conforme',
      DIPLOME_MAUVAIS_DOCUMENT: 'diplome_mauvais_document',

      LIVRET_FAMILLE_MAUVAIS_DOCUMENT: 'livret_famille_mauvais_document',
      LIVRET_FAMILLE_NON_CONFORME: 'livret_famille_non_conforme',

      PHOTO_IDENTITE_MAUVAIS_DOCUMENT: 'photo_identite_mauvais_document',
      PHOTO_IDENTITE_NON_EXPLOITABLE: 'photo_identite_non_exploitable',
    };
    return input ? mapping[input] : undefined;
  }

  public static toGraphQl(
    input?: NonConformiteCategorie
  ): NonConformiteCategorieEnum | undefined {
    const mapping: Record<NonConformiteCategorie, NonConformiteCategorieEnum> = {
      informations_manquantes: NonConformiteCategorieEnum.InformationsManquantes,
      mauvaise_qualite: NonConformiteCategorieEnum.MauvaiseQualite,
      recto_manquant: NonConformiteCategorieEnum.RectoManquant,
      verso_manquant: NonConformiteCategorieEnum.VersoManquant,

      jd_non_signe_formateur: NonConformiteCategorieEnum.JdNonSigneFormateur,
      jd_non_signe_filleul: NonConformiteCategorieEnum.JdNonSigneFilleul,
      jd_non_signe_formateur_filleul:
        NonConformiteCategorieEnum.JdNonSigneFormateurFilleul,
      jd_consultant_non_manager: NonConformiteCategorieEnum.JdConsultantNonManager,
      jd_plus_un_an: NonConformiteCategorieEnum.JdPlusUnAn,
      jd_ancienne_version: NonConformiteCategorieEnum.JdAncienneVersion,
      jd_mauvais_document: NonConformiteCategorieEnum.JdMauvaisDocument,

      esp_mauvais_document_formulaire:
        NonConformiteCategorieEnum.EspMauvaisDocumentFormulaire,
      esp_mauvais_document: NonConformiteCategorieEnum.EspMauvaisDocument,
      esp_non_signe_animateur: NonConformiteCategorieEnum.EspNonSigneAnimateur,
      esp_non_signe_filleul: NonConformiteCategorieEnum.EspNonSigneFilleul,
      esp_non_signe_animateur_filleul:
        NonConformiteCategorieEnum.EspNonSigneAnimateurFilleul,
      esp_absence_nom_parrain: NonConformiteCategorieEnum.EspAbsenceNomParrain,
      esp_ancienne_version: NonConformiteCategorieEnum.EspAncienneVersion,

      pi_cni_mauvais_document: NonConformiteCategorieEnum.PiCniMauvaisDocument,
      pi_cni_expire_mineur: NonConformiteCategorieEnum.PiCniExpireMineur,
      pi_cni_expire_majeur: NonConformiteCategorieEnum.PiCniExpireMajeur,
      pi_pass_mauvais_document: NonConformiteCategorieEnum.PiPassMauvaisDocument,
      pi_pass_expire: NonConformiteCategorieEnum.PiPassExpire,
      pi_ts_mauvais_document: NonConformiteCategorieEnum.PiTsMauvaisDocument,
      pi_ts_expire: NonConformiteCategorieEnum.PiTsExpire,
      pi_ts_bientot_expire: NonConformiteCategorieEnum.PiTsBientotExpire,

      ct_mauvais_document: NonConformiteCategorieEnum.CtMauvaisDocument,
      ct_expire: NonConformiteCategorieEnum.CtExpire,
      ct_nom_societe_invalide: NonConformiteCategorieEnum.CtNomSocieteInvalide,

      ss_mauvais_document: NonConformiteCategorieEnum.SsMauvaisDocument,
      ss_objet_invalide: NonConformiteCategorieEnum.SsObjetInvalide,
      ss_non_signe: NonConformiteCategorieEnum.SsNonSigne,

      kbis_mauvais_document: NonConformiteCategorieEnum.KbisMauvaisDocument,
      kbis_plus_trois_mois: NonConformiteCategorieEnum.KbisPlusTroisMois,
      kbis_mauvaise_societe: NonConformiteCategorieEnum.KbisMauvaiseSociete,
      kbis_plusieurs_gerants: NonConformiteCategorieEnum.KbisPlusieursGerants,
      kbis_gerant_different_societe:
        NonConformiteCategorieEnum.KbisGerantDifferentSociete,
      kbis_gerent_different_filleul:
        NonConformiteCategorieEnum.KbisGerentDifferentFilleul,
      kbis_activites_invalides: NonConformiteCategorieEnum.KbisActivitesInvalides,

      // ------- ValidationPj -------
      rcp_carteT_non_couverte: NonConformiteCategorieEnum.RcpCartetNonCouverte,
      rcp_expire: NonConformiteCategorieEnum.RcpExpire,
      rcp_habilitation_non_couverte:
        NonConformiteCategorieEnum.RcpHabilitationNonCouverte,
      rcp_identite_non_conforme: NonConformiteCategorieEnum.RcpIdentiteNonConforme,
      rcp_incomplete: NonConformiteCategorieEnum.RcpIncomplete,
      rcp_mauvais_document: NonConformiteCategorieEnum.RcpMauvaisDocument,

      rsac_identite_non_conforme: NonConformiteCategorieEnum.RsacIdentiteNonConforme,
      rsac_mauvais_document: NonConformiteCategorieEnum.RsacMauvaisDocument,
      rsac_plus_trois_mois: NonConformiteCategorieEnum.RsacPlusTroisMois,

      rib_compte_joint: NonConformiteCategorieEnum.RibCompteJoint,
      rib_non_conforme: NonConformiteCategorieEnum.RibNonConforme,

      att_formation_aucune_activite_stefi:
        NonConformiteCategorieEnum.AttFormationAucuneActiviteStefi,
      att_formation_aucune_formation_continue:
        NonConformiteCategorieEnum.AttFormationAucuneFormationContinue,
      att_formation_identite_non_conforme:
        NonConformiteCategorieEnum.AttFormationIdentiteNonConforme,
      att_formation_mauvais_document:
        NonConformiteCategorieEnum.AttFormationMauvaisDocument,
      att_formation_quota_heure: NonConformiteCategorieEnum.AttFormationQuotaHeure,
      att_formation_validate_avant_hab:
        NonConformiteCategorieEnum.AttFormationValidateAvantHab,
      certificat_travail_identite_non_conforme:
        NonConformiteCategorieEnum.CertificatTravailIdentiteNonConforme,
      certificat_travail_mauvais_document:
        NonConformiteCategorieEnum.CertificatTravailMauvaisDocument,
      diplome_identite_non_conforme:
        NonConformiteCategorieEnum.DiplomeIdentiteNonConforme,
      diplome_mauvais_document: NonConformiteCategorieEnum.DiplomeMauvaisDocument,
      livret_famille_mauvais_document:
        NonConformiteCategorieEnum.LivretFamilleMauvaisDocument,
      livret_famille_non_conforme: NonConformiteCategorieEnum.LivretFamilleNonConforme,
      photo_identite_mauvais_document:
        NonConformiteCategorieEnum.PhotoIdentiteMauvaisDocument,
      photo_identite_non_exploitable:
        NonConformiteCategorieEnum.PhotoIdentiteNonExploitable,
    };
    return input ? mapping[input] : undefined;
  }
}
